var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 55,
    height: 41,
    x: -1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.5v40.1H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc621",
    fillRule: "evenodd",
    d: "M-13.9.3h81.4v39H-14z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef2118",
    fillRule: "evenodd",
    d: "M-14 26.8h81.4v13.3H-14z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#298c08",
    fillRule: "evenodd",
    d: "M-13.9 0h81.4v14.1H-14z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006bc6",
    d: "M25.4 29.2a8.4 8.4 0 1 0 0-17 8.4 8.4 0 0 0 0 17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc621",
    fillRule: "evenodd",
    d: "m21.6 14.7-.5.4 1.8 2.6.5-.3zm2.3 6.2-.8-.6.3-1h-3.7l-1.1-.8h5.1l1-2.9.5 1.2zm6-5.6-.5-.4-2 2.6.5.3zm-5.1 4 .2-.8h1l-1-3.6.4-1.3 1.7 4.9h3l-1 .9zm7 4 .3-.5-3-1-.3.5zm-5.4-3.6h1l.3 1 3-2.2h1.4l-4.2 3 1 3-1.2-.7zm-1.5 8h.6v-3.1H25zm1.7-6.3.3.9-.8.6 3 2.2.4 1.3-4.2-3-2.4 1.8.3-1.2zm-8 1 .1.6 3-1-.1-.5zm6.4-.3-.7.6-.8-.6-1.2 3.6-1 .8 1.4-5-2.4-1.7 1.3-.2z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt);
export default __webpack_public_path__ + "static/media/et.9b89438848b11720734b44ce92cad188.svg";
export { ForwardRef as ReactComponent };